module.exports = __webpack_public_path__ + "img/service-gray.eb126921.svg";